<template>
  <div>
    <v-card class="pl-5 pr-5 pb-5">
      <div class="row">
        <div class="col">
          <h1>User Downloads</h1>
          <v-divider></v-divider>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Downloaded Date</th>
                  <th class="text-left">User Name</th>
                  <th class="text-left">Email</th>
                  <th class="text-left">Title</th>
                  <th class="text-left">Organization</th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id">
                  <td>{{ item.downloadDate | formatDateTime }}</td>
                  <td>{{ item.user.firstName }} {{ item.user.lastName }}</td>
                  <td>{{ item.user.email }}</td>
                  <td>{{ item.publication.Title }}</td>
                  <td>
                    {{
                      item.organization == null ? "" : item.organization.Name
                    }}
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import * as api from "@/api";
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";

export default {
  name: "UserDownloads",
  props: {
    userId: { type: Number, required: true },
  },
  watch: {},
  components: {
    Notification,
    ConfirmationDialog,
    Pagination
  },
  created() {
    this.getUserDevicesByPagin();
  },
  methods: {
    getUserDevicesByPagin() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("user-downloads", this.paging)
          .then((response) => {
            this.paging.count = response.data.count;
            this.list = response.data.data;
            console.log(this.list);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      this.paging.keyword = this.Search;
      console.log(this.paging);

      this.getUserDevicesByPagin();
    },
  },
  data() {
    return {
      list: [],
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      Search: "",
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/UserDownloads.vue